import { CheckIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";

const ColorCheckbox = ({ color, checked, onChange }: any) => {
  return (
    <>
      <input className="hidden" type="checkbox" name={`color-${color}`} />
      <div
        className={classNames(
          "flex items-center justify-center w-5 h-5 inline-block m-0.2 rounded-sm border border-solid border-gray-500 cursor-pointer",
          {
            "outline outline-1 outline-black outline-offset-1": checked,
            "outline outline-1 outline-transparent outline-offset-1": !checked,
          }
        )}
        data-color={color}
        style={{ backgroundColor: color }}
        onClick={onChange}
      >
        {checked && <CheckIcon className="h-4 w-4 text-white" />}
      </div>
    </>
  );
};

export default ColorCheckbox;
